/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-03 17:39:44
 * @LastEditors: 刘小博
 * @Description:
 * 主数据系统路由菜单
 */

import customerArchivesRouter from './modules/customerArchivesRouter'
import productLibraryRouter from './modules/productLibraryRouter'
import basicInformationRouter from './modules/basicInformationRouter'

const masterDataMaintainRouter = [].concat(
  customerArchivesRouter,
  productLibraryRouter,
  basicInformationRouter,
)
export default masterDataMaintainRouter
